// extracted by mini-css-extract-plugin
export var deleteIcon = "_qr-5";
export var deleteOption = "_qr-3";
export var divider = "_qr-2";
export var downloadIcon = "_qr-4";
export var drawer = "_qr-0";
export var drawerFooter = "_qr-6";
export var drawerOpen = "_qr-1";
export var highlighted = "_qr-7";
export var lighterHighlight = "_qr-8";